import { useSession } from 'next-auth/react';
import { useMutation } from '@tanstack/react-query';
import { api } from '@/libs/axios/api';
import { apiConfig } from '@/config/api';

const sendVisitPath = async (url: string, values: Payload) =>
  await api.post(url, values);

export const useSendVisitPath = () => {
  const { data: session } = useSession();

  const url =
    session && session.access_token
      ? apiConfig.routes.customer.sendVisit
      : apiConfig.routes.customer.sendVisitPublic;

  return useMutation({
    mutationFn: (values: Payload) => sendVisitPath(url, values),
  });
};

type Payload = {
  label: string;
  origin: string;
  time?: boolean;
  device_code?: string;
};
